import React from "react";
import styled from "styled-components";

import { translations } from "../../../utils/translations.js";
import { useSelector } from "react-redux";

const Wrapper = styled.div`
  height: 100%;
  width: 75%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-direction: column;
  @media (max-width: 768px) {
    overflow-x: auto; /* Permite derularea pe orizontală */

    padding: 1rem;
  }
`;

const PageTitle = styled.h2`
  color: var(--secondary-font-color);
  text-align: center;
  font-family: Georgia, serif;
  width: 75%;
`;

const SubTitle = styled.h3`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  width: 100%;
`;

const Text = styled.p`
  color: var(--secondary-font-color);
  text-align: justify;
  font-family: Verdana, sans-serif;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%; /* Pe mobil, ocupă întreaga lățime */
  }
`;

const TextSection = styled.div`
  color: var(--secondary-font-color);
  font-family: Verdana, sans-serif;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TermsPage = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);
  if (languageCode === "ro")
    return (
      <Wrapper>
        <PageTitle>
          {translations[languageCode]["footer-terms-section"]}
        </PageTitle>

        <TextSection>
          <Text>
            Folosirea acestui site implică acceptarea termenilor și condițiilor
            de mai jos. Recomandăm citirea cu atenție a acestora. FiloPrint își
            asumă dreptul de a modifica aceste prevederi fără o altă notificare.
            Cea mai recentă versiune poate fi accesată în această pagină.
          </Text>
          <SubTitle>Produse</SubTitle>
          <Text>
            Prin achiziționarea unui produs, clientul își asumă în totalitate 
            <a href="/retur"> Politica de Retur</a>.
          </Text>
          <Text>
            Produsele prezentate pe acest site sunt produse și comercializate de
            FiloPrint. Prețurile produselor pot fi schimbate oricând. Verificați
            prețul final de vânzare înainte de a achiziționa un produs. Toate
            produsele noastre sunt realizate odată cu plasarea unei comenzi,
            deoarece fiecare print este construit după viziunea clienților.
            Tehnologia de imprimare 3D ne permite să realizăm produsele într-un
            timp scurt pentru ca apoi să fie livrate către dumneavoastră. Cu
            toate acestea, durata de livrare poate varia până la 10 zile.
          </Text>
           <Text>
            FiloPrint își rezervă dreptul de a fotografia produsele, fie ele
            standard, personalizate sau custom, și de a folosi aceste materiale
            în scop publicitar. Clientul nu are dreptul de a contesta publicarea
            fotografiilor produselor comandate.
          </Text>
          <SubTitle>Date cu caracter personal</SubTitle>
         
          <Text>
          Prin completarea și transmiterea datelor de contact, clientul declară că este de acord ca datele sale cu caracter personal să fie colectate, prelucrate și utilizate de către Filoprint exclusiv în scopul preluării, procesării și realizării comenzii, precum și pentru comunicări legate de aceasta.
          Clientul își exprimă consimțământul de a fi contactat, prin orice mijloc de comunicare furnizat (telefon, e-mail, mesaje), în orice moment, în legătură cu comanda sau serviciile solicitate.
          Datele cu caracter personal vor fi prelucrate în conformitate cu legislația în vigoare privind protecția datelor (Regulamentul UE 2016/679 – GDPR). Clientul are dreptul de acces, rectificare, ștergere, restricționare a prelucrării și retragere a consimțământului în orice moment, printr-o solicitare scrisă.
          </Text>
         
          <SubTitle>Site</SubTitle>
          <Text>
            Vizitarea acestui website de către dumneavoastră se supune
            Termenilor și condițiilor de utilizare, și implică acceptul explicit
            al dumneavoastră cu privire la acestea și reprezintă înțelegerea
            dintre părți. Relația dintre părți este guvernată de următoarele
            acte normative: OG nr. 21/1992 privind protecția consumatorilor, OUG
            nr. 34/2014 privind drepturile consumatorilor în cadrul contractelor
            încheiate cu profesioniștii, Legea nr. 363/2007 privind combaterea
            practicilor incorecte ale comercianților în relația cu consumatorii
            și armonizarea reglementărilor cu legislația europeană privind
            protecția consumatorilor, Legea 365/2002 privind comerțul
            electronic. FiloPrint garantează utilizatorului acces limitat, în
            interes personal (efectuarea de comenzi online, informare), pe
            site-ul curent și nu îi conferă dreptul de a descărca sau de a
            modifica parțial sau integral site-ul, de a reproduce parțial sau
            integral site-ul, de a copia, de a vinde/revinde sau de a exploata
            site-ul în orice altă manieră, în scopuri comerciale sau fără
            acordul prealabil scris al acesteia. Întregul conținut al site-ului
            curent - imagini, texte, grafice, simboluri, elemente de grafică
            web, email-uri, scripturi, programe și alte date - este proprietatea
            FiloPrint și a furnizorilor săi și este apărat de Legea pentru
            protecția drepturilor de autor (legea nr. 8/1996) și de legile
            privind proprietatea intelectuală și industrială. Folosirea fără
            acordul FiloPrint a oricăror elemente enumerate mai sus se
            pedepseste conform legislației în vigoare. Utilizarea acestei mărci,
            a domeniului sau a numelor de comercializare, siglelor și
            emblemelor, în formă directă sau „ascunsă” (de tipul, dar nu limitat
            la, meta taguri sau alte tehnici de indexare, căutare web) fără
            permisiunea prealabilă scrisă este interzisă și se pedepseste
            conform legii.
          </Text>
        </TextSection>
      </Wrapper>
    );
  else
    return (
      <Wrapper>
        <PageTitle>
          {translations[languageCode]["footer-terms-section"]}
        </PageTitle>

        <TextSection>
          <Text>
            Using this site implies acceptance of the terms and conditions
            below. We recommend carefully reading these terms. FiloPrint
            reserves the right to modify these provisions without further
            notification. The most recent version can be accessed on this page.
          </Text>
          <SubTitle>Products</SubTitle>
          <Text>
            By purchasing a product, the customer fully accepts the{" "}
            <a href="/retur">Return Policy</a>.
          </Text>
          <Text>
            The products displayed on this site are produced and marketed by
            FiloPrint. Prices may change at any time. Please check the final
            sale price before purchasing any product. All our products are made
            upon placing an order, as each print is built according to the
            customer’s vision. The 3D printing technology allows us to create
            products in a short time, and then they are delivered to you.
            However, the delivery time may vary up to 10 days.
          </Text>
          <Text>
            FiloPrint reserves the right to photograph the products, whether
            they are standard, customized, or custom, and to use these materials
            for advertising purposes. The customer has no right to contest the
            public release of photos of the products ordered.
          </Text>

             <SubTitle>Personal data</SubTitle>
         
          <Text>
        By completing and submitting the contact details, the customer declares that he/she agrees that his/her personal data will be collected, processed and used by Filoprint exclusively for the purpose of taking over, processing and fulfilling the order, as well as for communications related to it.
The customer expresses his/her consent to be contacted, by any means of communication provided (telephone, e-mail, messages), at any time, in connection with the order or the requested services.
Personal data will be processed in accordance with the legislation in force on data protection (EU Regulation 2016/679 – GDPR). The customer has the right to access, rectify, delete, restrict processing and withdraw consent at any time, by written request.        </Text>
          <SubTitle>Site</SubTitle>
          <Text>
            Visiting this website by you is subject to the Terms and Conditions
            of use, and implies your explicit acceptance of these terms and
            represents the understanding between the parties. The relationship
            between the parties is governed by the following regulations: OG no.
            21/1992 regarding consumer protection, OUG no. 34/2014 regarding
            consumer rights in contracts concluded with professionals, Law no.
            363/2007 regarding the fight against unfair commercial practices
            with consumers, and harmonization of regulations with European Union
            legislation regarding consumer protection, Law 365/2002 regarding
            electronic commerce. FiloPrint guarantees the user limited access
            for personal use (placing online orders, obtaining information) on
            this website and does not grant the right to download or modify the
            site partially or in full, to reproduce it partially or in full, to
            copy, sell/resell, or exploit the site in any other manner for
            commercial purposes or without prior written consent. The entire
            content of the current website – images, texts, graphics, symbols,
            web graphics, emails, scripts, programs, and other data – is the
            property of FiloPrint and its suppliers and is protected by the
            Copyright Law (Law no. 8/1996) and intellectual and industrial
            property laws. The unauthorized use of any of the elements listed
            above is punishable under applicable law. The use of this trademark,
            domain name, trade names, logos, and emblems, whether directly or
            "hidden" (e.g., meta tags or other web search and indexing
            techniques) without prior written permission is prohibited and
            punishable by law.
          </Text>
        </TextSection>
      </Wrapper>
    );
};

export default TermsPage;
